import { _GLOBALS } from '../globals.js';
import { logit } from "./simpleLog.js";

export function detectPlatform() {
  if (typeof navigator === "undefined") {
    return "Other";
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    return "iOS";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  return "Other";
}

if(_GLOBALS.DebugMode) logit(`detectPlatform: ${detectPlatform()}`);
